import { FormattedMessage } from 'react-intl';

import { PreRenderedFormattedMessageProps } from './PreRenderedFormattedMessageProps';

export const AwaitingValuation = (props: PreRenderedFormattedMessageProps) => (
  <FormattedMessage id="awaiting-valuation" defaultMessage="Awaiting Valuation" {...props} />
);
